// Lucide icon: credit-card (https://lucide.dev/icons/credit-card)
import { CreditCard } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCreditCard = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CreditCard />
    </IconComponentStyled>
  )
}
